import { useTranslation } from 'react-i18next';
import { useLocaleStore } from '@/store/locale';
import type { Locale } from '@/api/types';
import { useUpdateServerLocale } from '@/api/queries/user';
import { useAuthStore } from '@/store/auth';

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = useLocaleStore((s) => s.locale);
  const hasToken = useAuthStore((s) => s.hasToken);
  const updateServer = useUpdateServerLocale();

  const setLocale = async (l: Locale) => {
    await i18n.changeLanguage(l);
    if (hasToken) {
      try {
        await updateServer.mutateAsync(l);
      } catch {
        /* server sync best-effort */
      }
    }
  };

  return { locale, setLocale, isRtl: i18n.dir() === 'rtl' };
}
